// extracted by mini-css-extract-plugin
export var formContainer = "_i5-0";
export var message = "_i5-1";